import React from "react";

import { useTheme } from "../../context/ThemeContext";
import CirclesOutline from "../../images/icons/circles-outline.inline.svg";
import { Link } from "../../utils/customLink";
import { formatCurrencyAmount } from "../../utils/formatContent";

export const VIGrant = ({
  title,
  description,
  promoFirstText,
  promoMiddleText,
  promoLastText,
  fallbackBgImage,
  grantAmount,
  applyLink
}) => {
  const { currentSiteMeta } = useTheme();

  const currencyToUse = currentSiteMeta?.currency
    ? currentSiteMeta.currency.toLowerCase()
    : process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";

  const exclusiveDiscount =
    grantAmount.find(
      (discount) => discount.viGrantAmountCurrency === currencyToUse
    ) ?? [];

  const scholarshipAmount = exclusiveDiscount?.viGrantAmountAmount ?? "1000";

  const scholarshipAmountDisplay = formatCurrencyAmount({
    currentSiteMeta,
    amount: scholarshipAmount
  });

  const scholarshipDisplayDescription = description.replace(
    "SHORTCODE_VIGrant",
    scholarshipAmountDisplay
  );

  const scholarshipTitle = title.replace(
    "SHORTCODE_VIGrant",
    scholarshipAmountDisplay
  );

  const promoMiddleTitle = promoMiddleText.replace(
    "SHORTCODE_VIGrant",
    scholarshipAmountDisplay
  );

  return (
    <div
      className="flex justify-center items-center bg-cover bg-no-repeat bg-center py-16 md:py-36"
      style={{ backgroundImage: `url('${fallbackBgImage}')` }}
    >
      <div className="w-11/12 md:gvi-container flex flex-col md:flex-row gap-9 md:gap-14">
        <div className="relative h-auto md:h-full mx-auto md:mb-9 w-2/3 md:w-auto">
          <CirclesOutline className="w-full md:w-auto" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
            <div
              className=" text-[26px] md:text-4xl font-light md:mb-3 text-white font-body"
              dangerouslySetInnerHTML={{ __html: promoFirstText }}
            />
            <div
              className="font-bold text-[38px] md:text-[54px] text-white font-body leading-none md:mb-3"
              dangerouslySetInnerHTML={{ __html: promoMiddleTitle }}
            />
            <div
              className="text-[26px] md:text-4xl font-light text-white leading-none md:leading-[70%]"
              dangerouslySetInnerHTML={{ __html: promoLastText }}
            />
          </div>
        </div>
        <div>
          <div
            className="mb-4 text-[34px] md:text-[55px] leading-10 md:leading-[62px] font-semibold font-body text-white"
            dangerouslySetInnerHTML={{ __html: scholarshipTitle }}
          />
          <div
            className="mb-12 md:w-3/4 text-white"
            dangerouslySetInnerHTML={{ __html: scholarshipDisplayDescription }}
          />
          <Link
            className="submit-button group flex md:inline-flex justify-center items-center px-20 py-2"
            to={applyLink}
          >
            <p className="pr-2 font-bold">Apply</p>
          </Link>
        </div>
      </div>
    </div>
  );
};
